"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.toObjectKeys = exports.getContextHelpersFromInitialValues = void 0;
var react_1 = require("react");
var ad_hok_1 = require("ad-hok");
var cleanupProps_1 = __importDefault(require("./cleanupProps"));
var addContextProvider_1 = __importDefault(require("./addContextProvider"));
var tuple_1 = __importDefault(require("./utils/tuple"));
var pick_1 = __importDefault(require("./utils/pick"));
var makeHelpers = function (_a) {
    var addProvider = _a.addProvider, addConsumer = _a.addConsumer, Context = _a.Context;
    return Object.assign(tuple_1.default(addProvider, addConsumer), {
        addProvider: addProvider,
        addConsumer: addConsumer,
        Context: Context,
    });
};
exports.getContextHelpersFromInitialValues = function (initialValues, propNames) {
    if (propNames === void 0) { propNames = Object.keys(initialValues); }
    var Context = react_1.createContext(initialValues);
    var valuePropName = '_getContextHelpers-value';
    var addProvider = ad_hok_1.flowMax(ad_hok_1.addProps(function (props) {
        var _a;
        return (_a = {},
            _a[valuePropName] = pick_1.default(propNames, props),
            _a);
    }, propNames), addContextProvider_1.default(Context, valuePropName), cleanupProps_1.default([valuePropName]));
    var addConsumer = ad_hok_1.flowMax(ad_hok_1.addContext(Context, valuePropName), ad_hok_1.addProps(function (_a) {
        var _b = valuePropName, propValue = _a[_b];
        if (!propValue)
            throw new MissingContextValueError("Missing context value that supplies " + propNames
                .map(function (propName) { return "\"" + propName + "\""; })
                .join(', ') + ", did you forget to render a provider?");
        return propValue;
    }, [valuePropName]), cleanupProps_1.default([valuePropName]));
    return makeHelpers({ addProvider: addProvider, addConsumer: addConsumer, Context: Context });
};
var getContextHelpers = function (propNamesObject) {
    return exports.getContextHelpersFromInitialValues(undefined, Object.keys(propNamesObject));
};
exports.default = getContextHelpers;
var MissingContextValueError = /** @class */ (function (_super) {
    __extends(MissingContextValueError, _super);
    function MissingContextValueError() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return MissingContextValueError;
}(Error));
exports.toObjectKeys = function (keys) {
    return keys.reduce(function (object, key) {
        var _a;
        return (__assign(__assign({}, object), (_a = {}, _a[key] = undefined, _a)));
    }, {});
};
